import { useAppDispatch, useAppSelector } from "./storeHook";
import { useCallback } from "react";
import {
  getGuides,
  getGuideById,
  addGuide,
  updateGuide,
  deleteGuide,
  setGuideCustomerSelection,
} from "actions/guideAction";

export function useGuides() {
  const dispatch = useAppDispatch();
  const { guides, selectedGuide, isLoading, error, selectedCustomerId } = useAppSelector(
    (state: any) => state.guide
  );

  const fetchGuides = useCallback(
    (customerId?: string) => {
      dispatch(getGuides(customerId));
    },
    [dispatch]
  );

  const fetchGuideById = useCallback(
    (id: string | number) => {
      dispatch(getGuideById(id));
    },
    [dispatch]
  );

  const createGuide = useCallback(
    (guide: any) => {
      dispatch(addGuide(guide));
    },
    [dispatch]
  );

  const updateGuideFn = useCallback(
    (guide: any) => {
      dispatch(updateGuide(guide));
    },
    [dispatch]
  );

  const deleteGuideFn = useCallback(
    (id: string | number) => {
      dispatch(deleteGuide(id));
    },
    [dispatch]
  );

  const setCustomerSelection = useCallback(
    (customerId: string | null) => {
      dispatch(setGuideCustomerSelection(customerId));
    },
    [dispatch]
  );

  return {
    guides,
    selectedGuide,
    isLoading,
    error,
    selectedCustomerId,
    fetchGuides,
    fetchGuideById,
    createGuide,
    updateGuide: updateGuideFn,
    deleteGuide: deleteGuideFn,
    setCustomerSelection,
  };
}
